// Blank starter templates for NEW homeowner projects created via the
// onboarding wizard. Keep these generic — no dollar amounts, no address-
// specific text, no trade-specific notes. The user fills them in.
//
// The existing projectData.js exports (defaultPhases, defaultBudgetCategories,
// defaultContractors) remain the founder's Shubert-specific seeded data —
// used only for the legacy dogfood project, not for new signups.

export const blankPhases = [
  {
    id: 1,
    name: "Pre-Application & Design",
    status: "not-started",
    durationWeeks: 8,
    startDate: "",
    endDate: "",
    tasks: [],
  },
  {
    id: 2,
    name: "Permits & Approvals",
    status: "not-started",
    durationWeeks: 12,
    startDate: "",
    endDate: "",
    tasks: [],
  },
  {
    id: 3,
    name: "Demolition",
    status: "not-started",
    durationWeeks: 2,
    startDate: "",
    endDate: "",
    tasks: [],
  },
  {
    id: 4,
    name: "Foundation & Framing",
    status: "not-started",
    durationWeeks: 6,
    startDate: "",
    endDate: "",
    tasks: [],
  },
  {
    id: 5,
    name: "Rough-In (MEP)",
    status: "not-started",
    durationWeeks: 4,
    startDate: "",
    endDate: "",
    tasks: [],
  },
  {
    id: 6,
    name: "Insulation & Drywall",
    status: "not-started",
    durationWeeks: 3,
    startDate: "",
    endDate: "",
    tasks: [],
  },
  {
    id: 7,
    name: "Interior Finishes",
    status: "not-started",
    durationWeeks: 5,
    startDate: "",
    endDate: "",
    tasks: [],
  },
  {
    id: 8,
    name: "Final Punch List & Inspection",
    status: "not-started",
    durationWeeks: 2,
    startDate: "",
    endDate: "",
    tasks: [],
  },
];

export const blankBudgetCategories = [
  { id: 1, name: "Architectural & Engineering", estimated: 0, actual: 0, notes: "" },
  { id: 2, name: "Permits & Fees", estimated: 0, actual: 0, notes: "" },
  { id: 3, name: "Demolition", estimated: 0, actual: 0, notes: "" },
  { id: 4, name: "Foundation", estimated: 0, actual: 0, notes: "" },
  { id: 5, name: "Framing", estimated: 0, actual: 0, notes: "" },
  { id: 6, name: "Electrical", estimated: 0, actual: 0, notes: "" },
  { id: 7, name: "Plumbing", estimated: 0, actual: 0, notes: "" },
  { id: 8, name: "HVAC", estimated: 0, actual: 0, notes: "" },
  { id: 9, name: "Insulation & Drywall", estimated: 0, actual: 0, notes: "" },
  { id: 10, name: "Flooring", estimated: 0, actual: 0, notes: "" },
  { id: 11, name: "Windows & Doors", estimated: 0, actual: 0, notes: "" },
  { id: 12, name: "Paint & Finishes", estimated: 0, actual: 0, notes: "" },
  { id: 13, name: "Fixtures & Hardware", estimated: 0, actual: 0, notes: "" },
  { id: 14, name: "Roofing", estimated: 0, actual: 0, notes: "" },
  { id: 15, name: "Contingency (10-15% recommended)", estimated: 0, actual: 0, notes: "" },
];

export const blankContractors = [
  { id: 1, name: "", role: "General Contractor", phone: "", email: "", website: "", notes: "" },
  { id: 2, name: "", role: "Architect / Designer", phone: "", email: "", website: "", notes: "" },
  { id: 3, name: "", role: "Structural Engineer", phone: "", email: "", website: "", notes: "" },
  { id: 4, name: "", role: "Electrician", phone: "", email: "", website: "", notes: "" },
  { id: 5, name: "", role: "Plumber", phone: "", email: "", website: "", notes: "" },
  { id: 6, name: "", role: "HVAC", phone: "", email: "", website: "", notes: "" },
];
